import { render, staticRenderFns } from "./uploadProductPic.vue?vue&type=template&id=6dbe0d79&scoped=true&lang=true&"
import script from "./uploadProductPic.vue?vue&type=script&lang=js&"
export * from "./uploadProductPic.vue?vue&type=script&lang=js&"
import style0 from "./uploadProductPic.vue?vue&type=style&index=0&id=6dbe0d79&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6dbe0d79",
  null
  
)

export default component.exports